import { _get } from "../../../../apiClient";
import config from "../../../../config";
import { _showToast } from "../../../../toastHelper";

export default async function FetchAndBindData(eventId, sections) {
    let eventData = await getData(eventId);
    if (eventData) {
        let data = JSON.parse(eventData.eventData);

        for (const section of sections) {
            if (section.sectionname == "demo") {
                bindDemoDetails(section, data);
            }
            else if (section.sectionname == "categories") {
                bindCategories(section, data);
            }
            else if (section.sectionname == "products") {
                bindProducts(section, data);
            }
            else if (section.sectionname == "studio") {
                section.data = data.studioId;
                section.isValid = true;
            }
            else if (section.sectionname == "theme") {
                bindThemeData(section, data);
            }
        }

        return {
            sections: sections,
            eventId: eventId,
            eventCode: eventData.eventCode
        };
    }
    return null;

}

const getData = async (eventId) => {
    return await _get("/events/" + eventId)
        .then((response) => {
            return response
        })
        .catch((error) => {
            _showToast(error, "error");
            return null;
        })
}

const bindDemoDetails = async (section, data) => {
    section.data = {
        title: data.demo.title,
        imageKey: data.demo.imageKey,
        imageFile: null,
        image: data.demo.imageKey ? config.imagesbaseurl + data.demo.imageKey : null
    }

    section.isValid = true;
}

const bindCategories = async (section, data) => {
    let categories = [];
    for (const category of data.categories) {
        categories.push({
            title: category.title
        })
    }
    section.data = categories;
    section.isValid = true;
}

const bindProducts = async (section, data) => {
    let products = [];
    for (const product of data.products) {
        products.push({
            title: product.title,
            youtubeLink: product.youtubeLink,
            ecommerceLink: product.ecommerceLink,
            category: product.category,
            description: product.description,
            isPrimary: product.isPrimary ?? false
        });
    }
    section.data = products;
    section.isValid = true;
}

const bindThemeData = async (section, data) => {
    let sliders = [];
    for (const slider of data.sliders) {
        sliders.push({
            image: slider.imageKey ? config.imagesbaseurl + slider.imageKey : null,
            imageFile: null,
            imageKey: slider.imageKey
        })
    }
    section.data = sliders;
    section.isValid = true;
}